import { heroImage } from '../data/copy'

const TITLE = 'Atletica 360 - Il Sistema Completo per Allenatori'
const DESCRIPTION =
  "Il sistema digitale completo in PDF per allenatori di atletica leggera: 6 volumi tecnici, 70+ sessioni pronte all'uso e 5 bonus. Pianifica l'intera stagione in 5 minuti."

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`,
  )
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.content = content
}

function appendLink(attrs: Record<string, string>): HTMLLinkElement {
  const link = document.createElement('link')
  Object.entries(attrs).forEach(([key, value]) => link.setAttribute(key, value))
  document.head.appendChild(link)
  return link
}

/**
 * Prepara el <head> antes del primer render:
 *
 * - idioma, título y metadatos sociales (SEO / compartir);
 * - precarga de la imagen del hero, que es el elemento LCP.
 *
 * La tipografía usa las pilas del sistema del design system (sans / serif),
 * así que no hay fuentes web que descargar.
 */
export function setupHead(): void {
  if (typeof document === 'undefined') return

  document.documentElement.lang = 'it'
  document.title = TITLE

  upsertMeta('name', 'description', DESCRIPTION)
  // zinc-950, el fondo de la página
  upsertMeta('name', 'theme-color', '#09090b')
  upsertMeta('property', 'og:type', 'website')
  upsertMeta('property', 'og:title', TITLE)
  upsertMeta('property', 'og:description', DESCRIPTION)
  upsertMeta('property', 'og:image', heroImage)
  upsertMeta('name', 'twitter:card', 'summary_large_image')
  upsertMeta('name', 'twitter:title', TITLE)
  upsertMeta('name', 'twitter:description', DESCRIPTION)
  upsertMeta('name', 'twitter:image', heroImage)

  if (document.head.querySelector('link[data-mp-head]')) return

  // Conexión anticipada al CDN de imágenes: ahorra DNS + TLS antes del LCP.
  appendLink({
    rel: 'preconnect',
    href: 'https://cdn.magicpatterns.com',
    crossorigin: '',
    'data-mp-head': 'cdn',
  })

  // La imagen del hero es el LCP: empieza a descargarse antes de que React monte.
  appendLink({
    rel: 'preload',
    as: 'image',
    href: heroImage,
    fetchpriority: 'high',
    'data-mp-head': 'hero',
  })
}
